// Environment detection utilities
const isK8s = process.env.K8S_DEPLOYMENT === 'true';
const isProduction = __ENV__ === 'production';

const config = {
  assets: {
    imagePath: process.env.NODE_ENV === 'development' ? '/products' : 'https://'
  },
  services: {
    // TODO: Add other services here
    recommendations: {
      apiUrl: (() => {
        if (isK8s) {
          return isProduction
            ? process.env.RECO_API_URL_PROD
            : process.env.RECO_API_URL_STAGING;
        }
        return process.env.RECO_API_URL;
      })()
    }
  }
};

Object.freeze(config);
Object.freeze(config.services);

export default config;
